import { useState } from "react";

export const useFileUpload = (maxSizeMB: number = 10) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > maxSizeMB * 1024 * 1024) {
        alert(`File size must be less than ${maxSizeMB}MB`);
        return;
      }
      setSelectedFile(file);
    }
  };

  const handleRemoveFile = (
    fileInputRef?: React.RefObject<HTMLInputElement>
  ) => {
    setSelectedFile(null);
    if (fileInputRef?.current) {
      fileInputRef.current.value = "";
    }
  };

  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        resolve(result.split(",")[1]);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  return {
    selectedFile,
    setSelectedFile,
    handleFileSelect,
    handleRemoveFile,
    convertFileToBase64,
  };
};
